import React from "react";
import ReactDOM from "react-dom/client";

import "bootstrap/dist/css/bootstrap.min.css";
import "./index.css";
 import "./styles/Header.css";
 import "./styles/Footer.css";
 import "./styles/Home.css";
 import "./styles/About.css";
 import "./styles/Contact.css";
import "./styles/blog/StoryCard.css";
import "./styles/blog/StoriesList.css";
import "./styles/blog/StoryPost.css";
import { i18nReady } from "./i18n";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { loadAnalytics } from "./analytics";

// Prerendered pages ship their full HTML: hydrate it in place instead of
// throwing it away and painting it again, which delayed the largest paint on
// slow phones. The dev server and unprerendered URLs start empty.
//
// The blog pages fetch their posts after the first render, so their first
// render (a loading state) can never match the prerendered post. They render
// fresh instead, after dropping the prerendered head tags that <Seo> is about
// to add again.
const container = document.getElementById("root");
const app = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
const prerendered = container.hasChildNodes();
const loadsDataAfterRender = /^\/(?:(?:hu|sr)\/)?stories(?:\/|$)/.test(window.location.pathname);

// The locale for the URL's language is its own chunk; wait for it so the first
// render produces the same text as the prerendered HTML.
i18nReady.then(() => {
  if (prerendered && !loadsDataAfterRender) {
    ReactDOM.hydrateRoot(container, app);
  } else {
    if (prerendered) {
      document.head
        .querySelectorAll('title, meta[name="description"], meta[name="robots"], meta[property^="og:"], meta[name^="twitter:"], link[rel="canonical"], link[rel="alternate"][hreflang]')
        .forEach((el) => el.remove());
    }
    ReactDOM.createRoot(container).render(app);
  }
  loadAnalytics();
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
